import styled from '@klappir/vendor/styled';

export const Break = styled.div`
  flex-basis: 100%;
  height: 0;
`;
